import React, { useState } from 'react';

import { IEquipmentProp } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentProp.dto';
import { IEquipmentUrl } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentUrl.dto';

import Tab from '@r1-frontend/ui-react/components/tabs/tab';

import * as ST from './styled';

export interface ICharacteristics {
    specifications?: IEquipmentProp[],
    howItWorks?: string,
    urls?: IEquipmentUrl[],
    description?: string,
}

const Characteristics = ({ specifications, urls, description }: ICharacteristics) => {
    const [activeTabLabel, setActiveTabLabel] = useState(description ? 'Полное описание' : 'Технические характеристики');

    const instructionUrl = urls?.filter(({ type, url }) => type === 'doc' && !!url);

    /**
     * TODO
     * Временный костыль, пока не разделят интерфейсы.
     * Подробнее тут: https://ticket.ertelecom.ru/browse/WEB-42073
     */
    const prepareSpecifications = (specifications || []).filter(spec => spec.title !== 'Предлагать в полной покупке' && spec.title !== 'Идентификатор provisioning');

    return (
        <ST.StyledTabs activeTab={activeTabLabel} onSwitchTab={setActiveTabLabel} data-test='characteristics-wrapper'>
            {!!description &&
                <Tab label='Полное описание'>
                    <ST.AliasContent dangerouslySetInnerHTML={{ __html: description }} data-test='characteristics-description'/>
                </Tab>}
            {prepareSpecifications.length &&
                <Tab label='Технические характеристики'>
                    <ST.AliasContent id='details' data-test='characteristics-specifications'>
                        {prepareSpecifications
                            .map((item) => (
                                <ST.ContentWrapper key={item.name}>
                                    <ST.ContentLabel>{item.title}:</ST.ContentLabel>
                                    {item.value}
                                </ST.ContentWrapper>
                            ))
                        }
                    </ST.AliasContent>
                </Tab>}
            {instructionUrl && instructionUrl?.length > 0 &&
                <Tab label='Инструкции по настройке'>
                    {instructionUrl.map((item) =>
                        <ST.AliasContent key={item.id} data-test='characteristics-how-it-works'>
                            <a href={item.url} target='_blank' rel='noreferrer noopener'>{item.name}</a>
                        </ST.AliasContent>)}
                </Tab>}
        </ST.StyledTabs>
    );
};

export default Characteristics;
